var _rect, _rect2, _rect3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 55,
    viewBox: "0 0 69 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2569,
    y: 1.2309,
    width: 51.1131,
    height: 33.7701,
    rx: 3,
    transform: "rotate(15.5029 10.2569 1.2309)",
    fill: "#FFEADB",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7402,
    y: 19.3711,
    width: 51.1131,
    height: 33.7701,
    rx: 3,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7402,
    y: 29.125,
    width: 51.1131,
    height: 4.50365,
    fill: "#4B4A50",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0975,
    cy: 43.3007,
    r: 3.25182,
    fill: "#FF7D23"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6786,
    cy: 43.3007,
    r: 3.25182,
    fill: "#E62645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPaymentMethod);
export default __webpack_public_path__ + "static/media/credit-card-payment-method.7d7a524d1705e1dd080311ac29386392.svg";
export { ForwardRef as ReactComponent };